import { StyledFormTextArea } from "./textArea.styles";

export const FormTextArea = ({ variant, ...props }) => {
  return <StyledFormTextArea $variant={variant} {...props} />;
};
